// Shared renderer for policy copy — used by the crawlable legal pages and
// the in-context modals so both always show identical text. Accepts either
// a plain `body` string or a structured policy ({ updated, intro, sections }).
export default function LegalBody({ body, updated, intro, sections, headingTag: H = "h2" }) {
  if (body) {
    return body.split("\n\n").map((p) => <p key={p.slice(0, 24)}>{p}</p>);
  }
  return (
    <>
      {updated && (
        <p className="text-xs font-semibold text-ink/45 uppercase tracking-wide">
          Last updated: {updated}
        </p>
      )}
      {intro && <p>{intro}</p>}
      {sections.map((s) => (
        <section key={s.h} className="pt-2">
          <H className="font-display uppercase text-base sm:text-lg tracking-wide text-ink">
            {s.h}
          </H>
          <div className="mt-2 space-y-3">
            {(s.paras || []).map((p) => (
              <p key={p.slice(0, 24)}>{p}</p>
            ))}
            {s.list && (
              <ul className="list-disc pl-5 space-y-1.5">
                {s.list.map((li) => (
                  <li key={li.slice(0, 24)}>{li}</li>
                ))}
              </ul>
            )}
            {(s.after || []).map((p) => (
              <p key={p.slice(0, 24)}>{p}</p>
            ))}
          </div>
        </section>
      ))}
    </>
  );
}
